import { TbAdjustments, TbBrain, TbClipboardText } from "react-icons/tb";

import { PERMISSIONS } from "@/constants/permissions";
import type { NavigationRoute } from "@/types/navigation-route";
import { APP_ROUTES_TO } from "@/utils/routes";

export const aiRoutes: NavigationRoute[] = [
    {
        to: APP_ROUTES_TO.AI,
        meta: {
            label: "ai",
            order: 6,
            icon: TbBrain,
            visibleInSidebar: true,
            permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
        },
        children: [
            {
                to: APP_ROUTES_TO.AI_DIMENSION_DEFINITIONS,
                meta: {
                    label: "dimension_definitions",
                    order: 1,
                    icon: TbClipboardText,
                    visibleInSidebar: true,
                },
            },
            {
                to: APP_ROUTES_TO.AI_DIMENSIONS,
                meta: {
                    label: "dimensions",
                    order: 2,
                    icon: TbAdjustments,
                    visibleInSidebar: true,
                },
            },
        ],
    },
];
